export const PRICE_APPLICATION_NOT_ALLOWED_MESSAGE = 'Você não tem permissão para aplicar preços. Peça a um Administrador para liberar seu acesso.';
